import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import qs from "qs";

const useTab = <T extends string>() => {
  const [searchParams] = useSearchParams();
  const params = useMemo(() => qs.parse(searchParams.toString()), [searchParams]);
  const { tab } = params as { tab?: T };

  return tab;
};

export default useTab;
